import { api, throwApiError } from "../../api/api";

/** Cobertura semanal do supervisor de campo (plan-notificacoes-whatsapp, 22/10/2026). */
export type CoverageStoreRow = {
  id: string;
  nomeFantasia: string;
  done: boolean;
  /** Dia da primeira visita na semana (`AAAA-MM-DD`). */
  referenceDate: string | null;
  evaluationId: string | null;
};

export type SupervisorCoverage = {
  user: { id: string; nomeCompleto: string };
  stores: CoverageStoreRow[];
  done: number;
  total: number;
};

export type MyCoverage = SupervisorCoverage & { weekStart: string; weekEnd: string };
export type AllCoverage = { weekStart: string; weekEnd: string; supervisors: SupervisorCoverage[] };

/** Lojas vinculadas ao supervisor de campo logado; `week` é qualquer dia da semana. */
export async function getMyCoverageApi(week?: string): Promise<MyCoverage> {
  try {
    const { data } = await api.get<MyCoverage>("/store-evaluations/coverage/mine", { params: week ? { week } : {} });
    return data;
  } catch (error) {
    return throwApiError(error, "Não foi possível carregar as suas lojas da semana.");
  }
}

/** Todos os supervisores de campo com loja vinculada (só ADMIN). */
export async function getAllCoverageApi(week?: string): Promise<AllCoverage> {
  try {
    const { data } = await api.get<AllCoverage>("/store-evaluations/coverage", { params: week ? { week } : {} });
    return data;
  } catch (error) {
    return throwApiError(error, "Não foi possível carregar a cobertura da semana.");
  }
}
